import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { updatesApi, updatesKeys } from '../updates.api';

/**
 * Bitácora de cambios del repositorio.
 *
 * El backend ya cachea un minuto, y al ampliar el límite se conservan los datos
 * anteriores (`placeholderData`) para que la lista no parpadee.
 */
export function useUpdates(limite: number) {
  return useQuery({
    queryKey: updatesKeys.changelog(limite),
    queryFn: ({ signal }) => updatesApi.changelog(limite, signal),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
